<template>
  <a-card>
    <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="6">
          <a-form-item label="资源标题">
            <a-input v-model.trim="searchForm.name" v-trim placeholder="资源标题" :maxLength="30" />
          </a-form-item>
        </a-col>
        <a-col :span="18">
          <a-row type="flex" justify="space-between">
            <a-col :span="12">
              <a-form-item label="">
                <a-button type="primary" style="margin-left: 16px; margin-right: 8px" @click="getPageList(1)">查询</a-button>
                <a-button @click=";(searchForm = {}), getPageList(1)">重置</a-button>
              </a-form-item>
            </a-col>
            <a-col>
              <a-button type="primary" icon="plus" @click="addModal">添加教学资源包</a-button>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <a-spin :spinning="tableRelevant.tableLoading">
      <div v-if="tableRelevant.tableDataSource.length <= 0" class="ant-table-content">
        <div class="ant-table-placeholder">暂无数据</div>
      </div>
      <div class="list">
        <RourceItem v-for="item in tableRelevant.tableDataSource" :key="item.id" class="item" :detail="item" :type="1" @del="delRecord(item)" @edit="editRecord(item)" @click.native="toDetail(item)">
        </RourceItem>
      </div>
      <div v-if="tableRelevant.tablePagination.total > 0" style="width: 100%; overflow: hidden">
        <a-pagination
          :showTotal="tableRelevant.tablePagination.showTotal"
          :total="tableRelevant.tablePagination.total"
          :pageSize="tableRelevant.tablePagination.pageSize"
          :page-size-options="['10', '20', '30']"
          show-size-changer
          show-quick-jumper
          :current="tableRelevant.tablePagination.current"
          @change="tableRelevant.tablePagination.onChange"
          @showSizeChange="tableRelevant.tablePagination.onShowSizeChange"
          style="float: right"
        />
      </div>
    </a-spin>

    <addSourceModal ref="addSourceModal" />
    <a-modal width="30%" title="编辑资源包" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
      <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 14 }" :form="form">
        <a-form-item label="资源包名称">
          <a-input style="width: 60%" :maxLength="20" v-decorator="['name', { rules: [{ message: '请输入资源包名称', required: true }] }]" />
        </a-form-item>
        <a-form-item label="可使用份数">
          <div style="display: flex; justify-content: space-between">
            <a-input
              style="width: 60%"
              @input="changeInput"
              @blur="blur"
              placeholder="请输入"
              v-decorator="[
                'maxCount',
                {
                  rules: [
                    { message: '请输入可使用份数', required: !form.getFieldValue('isLimitCount') },
                    {
                      validator: valid(),
                      message: '可使用份数不能小于已使用份数',
                    },
                  ],
                },
              ]"
              :disabled="form.getFieldValue('isLimitCount')"
            />
            <a-checkbox v-decorator="['isLimitCount', { valuePropName: 'checked', initialValue: false, rules: [{ message: '请选择', required: true }] }]"> 不限制 </a-checkbox>
          </div>
        </a-form-item>
        <a-form-item label="截止使用日期">
          <div style="display: flex; justify-content: space-between">
            <div style="width: 60%">
              <a-date-picker
                :disabled="form.getFieldValue('isLimitUsageDate')"
                style="width: 100%"
                :disabledDate="disabledDate"
                v-decorator="['uneffectiveDate', { rules: [{ message: '请选择截止使用日期', required: !form.getFieldValue('isLimitUsageDate') }] }]"
              />
            </div>
            <a-checkbox v-decorator="['isLimitUsageDate', { valuePropName: 'checked', initialValue: false, rules: [{ required: true, message: '请选择' }] }]"> 永久使用 </a-checkbox>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import RourceItem from '@/components/RourceItem'
import addSourceModal from '@/pages/projectImpl/orgManage/components/addSourceModal.vue'
import SelectTeachResourse from '@/pages/projectImpl/orgManage/components/selectTeachResourse.vue'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import moment from 'moment'

export default {
  components: { RourceItem, addSourceModal, SelectTeachResourse },
  data() {
    return {
      searchForm: {},
      visible: false,
      confirmLoading: false,
      tableRelevant: tableRelevant.call(this),
      form: this.$form.createForm(this, { name: 'coordinated' }),
      record: {},
    }
  },
  created() {
    this._params = {
      oId: this.$route.query.id,
      uneffectiveDate: this.$route.query.uneffectiveDate,
    }
    this.getPageList(1)
  },
  methods: {
    disabledDate(current) {
      // const uneffectiveDate = this._params.uneffectiveDate
      // || (current && current > moment(uneffectiveDate).endOf('day'))
      return current && current < moment().endOf('day')
    },
    toDetail(item) {
      const query = {
        id: item.id,
        params: JSON.stringify(item),
        oId: this._params.oId,
        uneffectiveDate: this._params.uneffectiveDate,
      }
      this.$router.push({ path: '/projectImpl/pMechanism/orgDetails/teachDetails', query })
    },
    blur() {
      let val = this.form.getFieldValue('maxCount')
      if (val == 0) {
        this.form.setFieldsValue({
          maxCount: 1,
        })
      }
    },
    changeInput(use) {
      let val = this.form.getFieldValue('maxCount')
      const Reg1 = `[^\\d\.]`
      const Reg2 = /^0(\d+)/
      const Reg3 = /^\./
      const Reg4 = /\.{1,}/g
      const Reg5 = /^(\d+)\.(\d\d).*$/
      val = String(val).replace(new RegExp(Reg1, 'g'), '')
      val = val
        .replace(Reg2, '$1')
        .replace(/(?=\-)/g, '')
        .replace(Reg3, '')
        .replace(Reg4, '')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(Reg5, '$1')
      this.form.setFieldsValue({
        maxCount: val,
      })
      return val
    },
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        organizationId: this._params.oId,
      }
      if(params.name===''){
        params.name = undefined
      }
      this.tableRelevant.tableLoading = true
      this.$http.CourseService.getResourseListByOrg(params).then((res) => {
        const { data } = res
        this.tableRelevant.tableLoading = false
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      })
    },
    valid() {
      return (_, val) => {
        if (val < this.record.usedCount) {
          return Promise.reject(new Error('可使用份数不能小于已使用份数'))
        }
        return Promise.resolve()
      }
    },
    handleOk() {
      this.form.validateFields((err, value) => {
        if (!err) {
          const params = [
            {
              ...this.record,
              ...value,
              isLimitCount: !value.isLimitCount,
              isLimitUsageDate: !value.isLimitUsageDate,
              organizationName: sessionStorage.getItem('ORGANIZATION_NAME'),
            },
          ]
          if (!params[0].isLimitUsageDate) {
            delete params[0].uneffectiveDate
          }

          this.$http.CourseService.resourseBatchEdit(params).then((res) => {
            this.$message.success('保存成功')
            this.handleCancel()
            this.getPageList(1)
          })
        }
      })
    },
    handleCancel() {
      this.record = {}
      this.visible = false
    },
    addModal(record = {}) {
      this.$refs['addSourceModal'].showModal({ ...record, oId: this._params.oId }, this._params.oId).then(() => {
        this.getPageList(1)
      })
    },
    delRecord(item) {
      this.$confirm({
        title: '确认信息?',
        content: (h) => {
          return h('div', {}, [
            `删除后资源包会从该机构消失，其相关所有数据都会被删除，该操作不可撤回，请谨慎操作。`,
            h('br'),
            '确认删除',
            h('span', { style: { color: '#57aaff' } }, [`【${item.name}】`]),
            '？',
          ])
        },
        onOk: () => {
          this.$http.CourseService.resourseBatchDel([item.id]).then((res) => {
            this.getPageList(1)
            this.$message.success('删除成功')
          })
        },
      })
    },
    editRecord(record) {
      this.record = { ...record }
      this.visible = true
      this.$nextTick(() => {
        if (!this.record.isLimitUsageDate) {
          delete this.record.uneffectiveDate
        }
        this.form.setFieldsValue({
          ...this.record,
          uneffectiveDate: this.record.uneffectiveDate,
          maxCount: this.record.maxCount,
          isLimitCount: !this.record.isLimitCount,
          isLimitUsageDate: !this.record.isLimitUsageDate,
        })
      })
    },
  },
}
</script>
<style lang="less" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  column-gap: calc((100% - 380px * 3) / 3);
  // margin: 0 max(20px ,calc((100% - 380px * 3) / 6));
  .item {
    margin-left: 20px;
  }
}
</style>
